import { ProductSKU } from 'jigsaw';

export const useProductSKUFields = (productSKU?: ProductSKU) => {
  const availability =
    productSKU?.availability ?? productSKU?.service.availability;
  const redemptionInstructions =
    productSKU?.redemptionInstructions ??
    productSKU?.service.redemptionInstructions;
  const termsAndConditions =
    productSKU?.termsAndConditions ?? productSKU?.service.termsAndConditions;
  const smallLogoImageURL = productSKU?.service.smallLogoImageURL;
  const skuTitle = productSKU?.title;
  const serviceTitle = productSKU?.service.title;
  const url = productSKU?.url;
  const serviceSlug = productSKU?.service.slug;

  return {
    availability,
    redemptionInstructions,
    termsAndConditions,
    smallLogoImageURL,
    skuTitle,
    serviceTitle,
    url,
    serviceSlug,
  };
};
